// extracted by mini-css-extract-plugin
export var description = "styles-module--description--fbab1";